import React, {useState} from "react"
import {useNavigate} from "react-router-dom"
import {toast} from "react-toastify"
import swal from "sweetalert"
import {getRandomConfirmWord, errorMessage} from "utils/utils"
import "./Submit.css"


export default function Submit(props) {

    const {rescue, data, edit} = props
    const canSubmit = rescue.permissions.submit && data.errors.length === 0    
    const navigate = useNavigate()
    const [confirmWord] = useState(getRandomConfirmWord().toLowerCase())
    const [typedWord, setTypedWord] = useState("")
    const mustConfirm = data.errors.length === 0 && data.warnings.length > 0
    const allGood = data.errors.length === 0 && data.warnings.length === 0
    
    
    const submit = () => {
        if (mustConfirm && confirmWord !== typedWord.toLowerCase()) {
            swal("Greška", `Reč nije dobro uneta. Probajte sa ’${confirmWord}’.`, "error")
            return
        }
        
        const toaster = toast.loading("Zaključujem...")
        rescue.submit(response => {
            toast.update(toaster, {render: "Zaključeno", type: "success", isLoading: false, autoClose: 2500})
            navigate('/')
        }, response => {
            toast.update(toaster, {render: `Neka greška [9]: ${errorMessage(response)}`, type: "error", isLoading: false, autoClose: 2500})
        })
    }
    
    return <section id="submit">
        <h1>Zaključivanje liste</h1>
    
        {data.errors.length > 0 && <div id="errors">
            <p>Ne možete zaključiti listu dok ne ispravite sledeće:</p>
            <ul>{data.errors.map(error => <li key={error}><i className="fa-solid fa-circle-exclamation"/> {error}</li>)}</ul>
        </div>}
        
        {data.warnings.length > 0 && <div id="warnings">
            <p>Pokušajte ispraviti sledeće podatke:</p>
            <ul>{data.warnings.map(warning => <li key={warning}><i className="fa-solid fa-triangle-exclamation"/> {warning}</li>)}</ul>
        </div>}
        
        {mustConfirm && <div id="confirm">
            <p>
                Ako ne možete ispraviti podatke, potvrdite da svejedno zaključujete listu
                tako što ćete u sledeće polje upisati reč <strong>’{confirmWord}’</strong>:
            </p>
            <input type="text" autoComplete="false" placeholder={`Upišite '${confirmWord}'...`} value={typedWord} onChange={e => setTypedWord(e.target.value)}/>
        </div>}
        
        {allGood && <p id="all-good">
            Svi potrebni podaci su uneti. Potvrdite zaključivanje.
        </p>}

        <div className="buttons">
            <button className="btn btn-light" onClick={edit}><i className="fa-solid fa-chevron-left"/><span>Ispravi</span></button>
            <button className="btn btn-primary" onClick={submit} disabled={!canSubmit}><i className="fas fa-lock"/><span>Zaključi</span></button>
        </div>
    </section>
}